import { Dispatch, ReactNode, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import { Modal } from "@/components/Interface/Modal/Modal";

export const HintOverlay = ({
  visible,
  setVisible,
  hint,
}: {
  visible: boolean;
  setVisible: Dispatch<SetStateAction<boolean>>;
  hint: ReactNode;
}) => {
  const { t } = useTranslation();

  if (!visible) {
    return null;
  }

  return (
    <Modal
      variant="dark"
      title={t("Onboarding.sections.sim-verification.hint.header")}
      onClose={() => setVisible(false)}
      hasScroll={false}
    >
      <div className="flex flex-col gap-6">
        <p className="text-body-base text-foreground-primary-inverse">
          {t("Onboarding.sections.sim-verification.hint.text")}
        </p>
        {hint}
      </div>
    </Modal>
  );
};
